// Seller "quantity to sell" for a Dropshipping In product (server: dropshippingInterne/services/sellerQuantityService.js).
// Same conventions as wholesaleService: plain JSON, never throws.
import { dsApi } from "./wholesaleService";

export const getSellerQuantities = (token, productId) => dsApi(token, "GET", `/seller/my-products/${encodeURIComponent(productId)}/quantities`);
// quantity: whole number (6..Provider quantity) or null to follow the Provider again.
export const setSellerQuantity = (token, productId, rowId, quantity) =>
  dsApi(token, "PUT", `/seller/my-products/${encodeURIComponent(productId)}/quantities/${encodeURIComponent(rowId)}`, { quantity });
